import { FC } from 'react';
import styled from 'styled-components';

import LocalizedLink from '@/components/LocalizedLink/LocalizedLink';
import { getImage } from '@/lib/fetchAPI';

const RelevantPost: FC<any> = ({ link, image, title }) => (
	<StoryItem>
		<LocalizedLink href={`/blog/post/${link}`}>
			<ImageWrapper>
				<img alt={title} src={getImage(image)} />
			</ImageWrapper>

			<h3>{title}</h3>
		</LocalizedLink>
	</StoryItem>
);

const StoryItem = styled.div`
	width: 29.5%;

	&:hover {
		img {
			transform: scale(1.1);
		}
	}

	@media (max-width: 900px) {
		width: 31%;
		max-width: 100%;
		margin-bottom: 20px;
	}

	@media (max-width: 600px) {
		width: 46%;
		margin-bottom: 25px;
	}

	@media (max-width: 440px) {
		width: 100%;
	}

	a {
		text-decoration: none;
	}

	h3 {
		display: block;
		padding-left: 10px;
		font-family: var(--font-sans);

		font-size: 25px;
		line-height: 35px;
		color: var(--color-white);
	}

	@media (max-width: 900px) {
		h3 {
			font-size: 20px;
		}
	}
`;

const ImageWrapper = styled.div`
	padding-top: 55%;
	position: relative;
	border-radius: 20px;
	overflow: hidden;
	margin-bottom: 23px;

	@media (max-width: 600px) {
		margin-bottom: 10px;
	}

	img {
		position: absolute;
		width: 100%;
		top: 0;
		left: 0;
		display: block;
		transition: 0.3s;
		object-fit: cover;
		object-position: center;
		height: 100%;
	}
`;

export default RelevantPost;
